import { EnvironmentConfig } from '@core/config/env.config';

export const environment: EnvironmentConfig = {
  production: true,
  name: 'prod',
  apiUrl: '/api',
  timeout: 60000, // 60 segundos para producción
  photoCaptureMode: 'multi', // Permitir múltiples fotos por remito
  maxPhotosPerRemito: 5,
  scannerMode: 'mobile', // Producción optimizada para móvil
  checkoutSyncIntervalMs: 60000,
  offlineSyncEnabled: true,
  serviceWorkerEnabled: true,
  devAutoGrantPermissions: false
};
